import React from "react";
import "./Planning.scss";
import { RouteComponentProps } from "react-router";
import { navigationStore } from "../../../stores/NavigationStore";
import { CallsClient } from "../../../Services/elco.API.Swagger";
import { headerStore } from "../../../stores/HeaderStore";
import { AvailableImgs } from "../../../Models/AvailableImgs";
import { footerStore } from "../../../stores/FooterStore";
import { backgroundStore } from "../../../stores/BackgroundStore";
import PageWithTablesTemplate from "../../../Components/PageWithTablesTemplate/PageWithTablesTemplate";

/*interface RowData {
	objectId: string;
	objectQty: number;
	localization: string;
	description: string;
}*/

type props = {
	contract: string;
	site: string;
};

type state = {
	contractId: string;
	siteId: string;
	contractName: string;
	siteName: string;
	selectedRow: any;
};

export default class Planning extends React.Component<
	RouteComponentProps<props>,
	state
> {
	constructor(props: RouteComponentProps<props>) {
		super(props);

		this.state = {
			contractId: props.match.params.contract,
			siteId: props.match.params.site,
			contractName: "",
			siteName: "",
			selectedRow: null,
		};

		navigationStore.setState({
			contractId: decodeURIComponent(this.state.contractId),
			siteId: decodeURIComponent(this.state.siteId),
			callId: null,
			title: "Planning des visites",
		});

		headerStore.setState({
			leftImgSrc: AvailableImgs.TwentyFourHDepanage,
			rightImgSrc: AvailableImgs.Logo,
			text: "Nous saurons vous convaincre par notre compétence",
		});

		footerStore.setState({
			show: true,
			leftText: null,
			centerText:
				"Prestation par du personnel hautement qualifié: électricien, mecatronicien, mécanicien, soudeur, tuyauteur, monteur-voltigeur",
			rightText: "www.elco.lu",
		});

		backgroundStore.setState({
			img: AvailableImgs.FondVehicule2,
		});
	}

	render() {
		return (
			<PageWithTablesTemplate
				className="planning"
				buttonCenter={{
					isEnableWhenRowSelected: false,
					label: "Retour",
					url: "/contracts/" + this.state.contractId + "/sites",
				}}
				buttonBottom={{
					isEnableWhenRowSelected: false,
					label: "Accueil",
					url: "/",
				}}
				tables={[
					{
						tableId: `planningTable_${this.state.contractId}_${this.state.siteId}`,
						promiseData: (options) =>
							new CallsClient().getPlannedMaintenances(
								this.state.contractId,
								this.state.siteId,
								options
							),
						colunsDefinition: [
							{ title: "Description de la visite", field: "visitDescription" },
							{ title: "Equipement", field: "objectId" },
							{ title: "Description de l’équipement", field: "objectName" },
						],
						onSelectedItemChange: (item) => {
							this.setState({ selectedRow: item });
						},
						dataKey: "objectId",
					},
				]}
			/>
		);
	}
}
